export default __webpack_public_path__ + "static/media/market2.a6f3b680.png";